<ng-container [formGroup]="formGroup">
  <lds-text-input
    formControlName="contactNumber"
    [label]="label"
    iconPrefix="phone"
    [placeholder]="placeholder"
    [minlength]="minLength"
    [maxlength]="maxLength"
    [isRequired]="isRequired"
    [showHighlight]="showHighlight"
    (sparkPasteNumbersOnly)="onPasteDigits($event)"
    [validations]="validations">
  </lds-text-input>
</ng-container>
